<template>
  <ContentList :type="statuses_.rejected"/>
</template>

<script>
import ContentList from '@/components/content/verification/ContentList.vue'
import { statuses } from '@/config/content/statuses'

export default {
  name: 'ContentRejected',
  components: { ContentList },
  data() {
    return {
      statuses_: statuses
    }
  }
}
</script>

<style scoped>

</style>
